export default function (vehicleId, keepers, createKeeper, close, toaster) {
    const vm = this;

    vm.model = {};

    vm.create = create;
    vm.closeModal = close;

    /* --- */

    function create() {
        if (vm.form.$invalid) {
            return;
        }

        createKeeper(vehicleId, vm.model)
        .then(() => {
            toaster.success('Keeper successfully  created');
            close();

            keepers.push({
                id: 'xxx',
                keeperPosition: keepers.length + 1,
                communicationStatus: {
                    allowedToSendCommunications: true
                },
                ...vm.model
            });
        })
        .catch(() => {
            toaster.error('An error occured while creating the keeper');
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/keepers/create/keeperCreateCtrl.js